var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFalcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_copy",
    "data-name": "Layer 2 copy",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 176.13 32.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#25282a;}.cls-2{fill:#cb2c30;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FalconType-RGB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TypeLockup"
  }, /*#__PURE__*/React.createElement("g", {
    id: "InsComp"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.52,36.2H2.63V28.94H4.52Z",
    transform: "translate(-2.63 -3.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.08,36.2H14l-2.25-3.93-.55-1.1h0l0,1.36V36.2H9.54V28.94h2.1l2.26,3.93.55,1.1h0l0-1.36V28.94h1.67Z",
    transform: "translate(-2.63 -3.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.37,29.13a3.86,3.86,0,0,1,1.36,1l-1.07,1.23a2.36,2.36,0,0,0-.85-.81,2.49,2.49,0,0,0-1.17-.26,1.63,1.63,0,0,0-.88.2.6.6,0,0,0-.31.53.51.51,0,0,0,.32.45,4.19,4.19,0,0,0,1.11.31,4.85,4.85,0,0,1,2.15.8,1.81,1.81,0,0,1,.64,1.49,1.89,1.89,0,0,1-.4,1.2,2.45,2.45,0,0,1-1.09.77,4.42,4.42,0,0,1-1.58.26,5.57,5.57,0,0,1-2-.3,3.47,3.47,0,0,1-1.33-.93l1-1.32a2.45,2.45,0,0,0,1,.84,3.14,3.14,0,0,0,1.3.24,1.91,1.91,0,0,0,.91-.17.54.54,0,0,0,.3-.49q0-.25-.32-.41a4.64,4.64,0,0,0-1.08-.3A8,8,0,0,1,21.76,33a2.27,2.27,0,0,1-.95-.7,1.8,1.8,0,0,1-.34-1.12A2.11,2.11,0,0,1,20.85,30a2.41,2.41,0,0,1,1.08-.84,4.25,4.25,0,0,1,1.68-.3A4.53,4.53,0,0,1,25.37,29.13Z",
    transform: "translate(-2.63 -3.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.62,33.24a3,3,0,0,1-.81,2.3,3.42,3.42,0,0,1-2.43.77,3.42,3.42,0,0,1-2.43-.77,3,3,0,0,1-.82-2.3v-4.3H33v4.33a1.76,1.76,0,0,0,.33,1.17,1.26,1.26,0,0,0,1,.38q1.36,0,1.36-1.55V28.94h1.88Z",
    transform: "translate(-2.63 -3.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.51,33.54H44.37V36.2H42.51V28.94H46a3.08,3.08,0,0,1,2,.59,2.11,2.11,0,0,1,.71,1.72,2.28,2.28,0,0,1-.36,1.32,2.12,2.12,0,0,1-1.06.78l1.85,2.85H47.06ZM44.37,32.2h1.29a1.41,1.41,0,0,0,.88-.22.85.85,0,0,0,.27-.7.84.84,0,0,0-.27-.69,1.41,1.41,0,0,0-.88-.22H44.37Z",
    transform: "translate(-2.63 -3.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.66,34.56H55.15l-.51,1.64h-1.9l2.55-7.26h2.27L60.1,36.2H58.16Zm-.4-1.29-.53-1.74-.32-1.14h0l-.3,1.13-.55,1.75Z",
    transform: "translate(-2.63 -3.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.13,36.2H69l-2.25-3.93-.55-1.1h0l0,1.36V36.2H64.58V28.94h2.1l2.25,3.93.55,1.1h0l0-1.36V28.94h1.67Z",
    transform: "translate(-2.63 -3.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.43,35.76a3.65,3.65,0,0,1-2,.54,3.85,3.85,0,0,1-1.9-.45,3,3,0,0,1-1.23-1.29,4.9,4.9,0,0,1,0-4,3,3,0,0,1,1.23-1.29,4.27,4.27,0,0,1,3.9.06,2.39,2.39,0,0,1,1.09,1.5l-1.66.67a1.66,1.66,0,0,0-.47-.92,1.38,1.38,0,0,0-.9-.26,1.47,1.47,0,0,0-1.24.58,2.73,2.73,0,0,0-.44,1.68,2.81,2.81,0,0,0,.42,1.68,1.43,1.43,0,0,0,1.23.58,1.48,1.48,0,0,0,1-.29,1.53,1.53,0,0,0,.48-.9l1.72.48A2.77,2.77,0,0,1,81.43,35.76Z",
    transform: "translate(-2.63 -3.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M92.84,34.73V36.2H87V28.94H92.7V30.4H88.94v1.47h3v1.37h-3v1.49Z",
    transform: "translate(-2.63 -3.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M109.24,35.76a3.65,3.65,0,0,1-2,.54,3.85,3.85,0,0,1-1.9-.45,3,3,0,0,1-1.23-1.29,4.9,4.9,0,0,1,0-4,3,3,0,0,1,1.23-1.29,4.27,4.27,0,0,1,3.9.06,2.39,2.39,0,0,1,1.09,1.5l-1.66.67a1.66,1.66,0,0,0-.47-.92,1.38,1.38,0,0,0-.9-.26,1.47,1.47,0,0,0-1.24.58,2.73,2.73,0,0,0-.44,1.68,2.81,2.81,0,0,0,.42,1.68,1.43,1.43,0,0,0,1.23.58,1.48,1.48,0,0,0,1-.29,1.53,1.53,0,0,0,.48-.9l1.72.48A2.77,2.77,0,0,1,109.24,35.76Z",
    transform: "translate(-2.63 -3.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M120,29.27a3,3,0,0,1,1.23,1.29,4.91,4.91,0,0,1,0,4A3,3,0,0,1,120,35.86a4.27,4.27,0,0,1-3.8,0A3,3,0,0,1,115,34.57a4.92,4.92,0,0,1,0-4,3,3,0,0,1,1.23-1.29,4.28,4.28,0,0,1,3.8,0Zm-3.11,1.61a2.84,2.84,0,0,0-.42,1.68,2.84,2.84,0,0,0,.42,1.68,1.41,1.41,0,0,0,1.21.57,1.39,1.39,0,0,0,1.21-.57,2.87,2.87,0,0,0,.41-1.68,2.87,2.87,0,0,0-.41-1.68,1.39,1.39,0,0,0-1.21-.57A1.41,1.41,0,0,0,116.9,30.88Z",
    transform: "translate(-2.63 -3.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M134.77,36.2H133.1V32.86l.05-2.23h0l-1.79,5.57h-1.53L128,30.63h0l.06,2.23V36.2h-1.68V28.94h2.7l1.14,3.7.41,1.54h0l.42-1.53,1.13-3.71h2.58Z",
    transform: "translate(-2.63 -3.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M145.42,29.56a2.23,2.23,0,0,1,.73,1.79,2.12,2.12,0,0,1-.73,1.72,3.14,3.14,0,0,1-2.08.61H141.9V36.2H140V28.94h3.33A3.11,3.11,0,0,1,145.42,29.56ZM144,32.05a.89.89,0,0,0,.29-.73.87.87,0,0,0-.29-.72,1.43,1.43,0,0,0-.91-.24H141.9v1.92H143A1.42,1.42,0,0,0,144,32.05Z",
    transform: "translate(-2.63 -3.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M154.19,34.56h-2.51l-.51,1.64h-1.9l2.55-7.26h2.27l2.54,7.26h-1.95Zm-.4-1.29-.53-1.74-.32-1.14h0l-.3,1.13-.55,1.75Z",
    transform: "translate(-2.63 -3.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M167.43,36.2h-2.1l-2.25-3.93-.55-1.1h0l0,1.36V36.2h-1.67V28.94H163l2.25,3.93.55,1.1h0l0-1.36V28.94h1.67Z",
    transform: "translate(-2.63 -3.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M176.2,33.54V36.2h-1.89V33.54l-2.56-4.61h2l1,2,.54,1.21.55-1.21,1-2h1.92Z",
    transform: "translate(-2.63 -3.78)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Falcon"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2.7,3.78H24.15v3.6H7.57v5.86h8.93V17H7.57v7.84H2.7Z",
    transform: "translate(-2.63 -3.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29.61,24.86H24.89l12-21.08h4.65L53.7,24.86H48.33l-2.54-4.46H32.05Zm4.53-8.31h9.61L38.94,8.12Z",
    transform: "translate(-2.63 -3.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60,3.88h4.87V21.09H80.91V25H60Z",
    transform: "translate(-2.63 -3.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M104.38,11.53V7.37H90.86V21.14h13.52V16.55l4.84,1V20.7c0,3.75-2.51,4.15-5.46,4.15H90.4c-3.57,0-4.4-2.17-4.4-4.74V8.52c0-3.88,1.74-4.74,5.27-4.74h12.34c4.9,0,5.55,1.67,5.55,4.15v2.91Z",
    transform: "translate(-2.63 -3.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M123.5,24.86c-3.57,0-5.05-1.27-5.05-4.74V8c0-3.53,2.39-4.22,5.05-4.22h16.06c4,0,5,1.58,5,4.22V20.12c0,3.47-1.27,4.74-5,4.74ZM139.69,21V7.53H123.32V21Z",
    transform: "translate(-2.63 -3.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M153,3.78h3.32l17.3,14.42V3.78h4.34V24.86H174.6L157.3,10.38V24.86H153Z",
    transform: "translate(-2.63 -3.78)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFalcon);
export default __webpack_public_path__ + "static/media/falcon.9baacab3b0d2597277b77ff8d2f16a31.svg";
export { ForwardRef as ReactComponent };